<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :account-group="accountGroup"
            :fulfillment-modules="fulfillmentModules"
            :change-module="changeModule"
            :account-tags="accountTags"
            :tags="tags"
            :account-options="accountOptions"
            :test-route="$route('products.account-groups.options.test-connection', { accountGroup: accountGroup.id })"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/FulfillmentAccountGroups/Form'

export default {
    name: 'FulfillmentAccountGroupUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        accountGroup: {
            type: Object,
            default () {
                return {}
            }
        },
        fulfillmentModules: {
            type: Array,
            default () {
                return []
            }
        },
        accountTags: {
            type: Array,
            default () {
                return []
            }
        },
        tags: {
            type: Array,
            default () {
                return []
            }
        },
        changeModule: {
            type: Boolean,
            default: false
        },
        accountOptions: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('products.account-groups.update', this.accountGroup.id))
        }
    }
}
</script>
